import { IS_DEPLOYED } from '../../config/FruitfulEnvironment';

export const isDatadogEnabled = (): boolean => {
    return IS_DEPLOYED;
};
